import { render } from "./SignInProblem.vue?vue&type=template&id=1184f4ff&scoped=true"
import script from "./SignInProblem.vue?vue&type=script&lang=js"
export * from "./SignInProblem.vue?vue&type=script&lang=js"

import "./SignInProblem.vue?vue&type=style&index=0&id=1184f4ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1184f4ff"]])

export default __exports__